import { useCallback } from 'react';
import { trackAnalytics, getTokenCount } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext, useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';

const useTrackOutputCopied = () => {
  const { productEvents } = useConfigContext();
  const { findMessagesBy } = useMessagesContext();
  const { sessionId } = useUiResourceContext();
  const { getChatSessionId } = useChatSessionId();

  const trackCallback = useCallback(
    ({ content, code }: { content: string; code: boolean }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);
      const chatSessionId = getChatSessionId();

      trackProductAnalytics('Output Copied', {
        'Message Content': content,
        'Message Character Count': content.length,
        'Message Includes Code': code,
        'Tokens Returned': getTokenCount(content),
        'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
        'Session ID': sessionId, // session id is set each time the drawer is opened
        'Chat Session ID': chatSessionId, // chat session id tracks the entire conversation history
      });
    },
    [productEvents, findMessagesBy, sessionId],
  );

  return trackCallback;
};

export default useTrackOutputCopied;
